import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { SettingsService } from 'src/app/services/settings.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-confirm-registration',
  templateUrl: './confirm-registration.component.html',
  styleUrls: ['./confirm-registration.component.scss'],
})
export class ConfirmRegistrationComponent implements OnInit {
  busy: boolean = false;
  errorMsg: string = '';
  showError: boolean = false;
  showSuccess: boolean = false;
  public confirmKey: string = '';
  public passwordKey: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private usersService: UserService,
    public settingsService: SettingsService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {}

  ngOnInit(): void {
    this.settingsService.routeHidden = false;

    this.route.paramMap.subscribe((params) => {
      const combined = params.get('combinedKeys');

      if (combined && combined.includes(':')) {
        const parts = combined.split(':');
        this.confirmKey = parts[0];
        this.passwordKey = parts[1];
      }
    });
    this.ConfirmRegistration();
  }

  public ConfirmRegistration() {
    this.busy = true;
    this.errorMsg = '';

    if (!this.confirmKey || !this.passwordKey) {
      this.showError = true;
      this.errorMsg = 'Invalid link, please contact support@dooya.co.za';
      this.busy = false;

      return;
    }

    this.recaptchaV3Service.execute('ConfirmRegistration').subscribe((token) => {
      this.usersService.ConfirmRegistration(this.confirmKey).subscribe(
        () => {
          this.busy = false;
          this.showSuccess = true;
          this.router.navigate(['confirmations/password-reset/' + this.passwordKey]);
        },
        (error) => {
          this.showError = true;
          this.errorMsg = error;
          this.busy = false;
        }
      );
    });
  }
}
